const Animations = () => {
     return (
          <div className='w-full flex justify-center md:justify-end items-center mx-6 md:-mx-6'>
               <img src={ require( '../assets/Gif-5.gif' ) } alt="loading..."
                    className='w-1/2 cursor-pointer' />
          </div>
     )
}

export default Animations
